import WaterMarkPlugin from './watermark'
export default WaterMarkPlugin



// WEBPACK FOOTER //
// ./src/plugins/watermark/index.js